export class AggregateDataService {
  constructor(
    Aggregates,
    CurrentModelService,
    CurrentFilterService,
    $rootScope,
    $q,
    ErrorHandlerService,
    rx,
    loadWithCache,
  ) {
    this.Aggregates = Aggregates;
    this.CurrentModelService = CurrentModelService;
    this.CurrentFilterService = CurrentFilterService;
    this.ErrorHandlerService = ErrorHandlerService;
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.loadWithCache = loadWithCache;

    this.aggregate = null;
    this.loading = false;
    this.loadingMore = false;
    this.isComplete = false;
    this.cancelled = false;
    this.cancelledMore = false;
    this.canceller = null;
    this.error = null;

    this.cancelSubject = new rx.Subject();
    this.loadMoreSubject = new rx.Subject();
    this.filterSubject = new rx.Subject();

    this.filterData$ = this.filterSubject.asObservable()
      .filter(() => {
        if (!this.CurrentModelService.cube) {
          console.error('model is not defined');
          return false;
        }
        return true;
      })
      .map((filter) => {
        if (!filter) {
          return null;
        }
        this.filter = filter;
        this.actualFilter = filter;
        return {
          filter: this.actualFilter,
          url   : this.getUrl(this.actualFilter),
          params: this.actualFilter.buildQueryParams(),
        };
      })
      .distinctUntilChanged(null, (params1, params2) => {
        return !this.cancelled && params1 && params2 &&
          params1.url === params2.url &&
          angular.equals(params1.params, params2.params);
      })
      .filter(params => params)
      .switchMap((params) => {
        if (this.loading || this.loadingMore) {
          this.onCancel();
        }
        this.aggregate = null;
        this.page = 0;
        params.params.page = this.page;
        this.beforeLoad();
        return rx.Observable.amb(
          this.cancelSubject.asObservable()
            .do(() => this.onCancel())
            .first(),
          rx.Observable.fromPromise(this.load(params))
            // .delay(10000)
            .do((data) => this.afterLoad(data))
            .catch((error) => {
              this.onError(error);
              this.error = error;
              return rx.Observable.of(null);
            }),
        )
          .flatMap((data) => {
            if (data === null) {
              return rx.Observable.of(null);
            }
            return rx.Observable.of(data).concat(this.loadMoreSubject.asObservable()
              .exhaustMap(() => rx.Observable.of(null).flatMap(() => {
                  if (this.isComplete) {
                    return rx.Observable.of(null);
                  }
                  this.page = this.page + 1;
                  params.params.page = this.page;
                  this.beforeLoad();
                  return rx.Observable.amb(
                    this.cancelSubject.asObservable()
                      .do(() => this.onCancel())
                      .first(),
                    rx.Observable.fromPromise(this.load(params))
                      .do((data) => this.afterLoad(data))
                      .catch((error) => {
                        this.onError(error);
                        return rx.Observable.of(null);
                      }),
                  );
                },
              ))
            );
          });
      })
      .share()
    ;
    this.subscription = this.filterData$
      .subscribe(
        () => {
          // console.log('aggregate page', this.filter && this.page);
        },
      );
  }

  init(force) {
    let result = this.filterData$.first().toPromise();
    this.CurrentFilterService.filterBar.copyFrom(
      this.CurrentFilterService.filter,
      true,
    );
    this.CurrentFilterService.filterBar.timeFrom = this.CurrentFilterService.timeFrom;
    this.CurrentFilterService.filterBar.timeTo = this.CurrentFilterService.timeTo;
    if (force) {
      this.filterSubject.onNext(null);
    }
    this.filterSubject.onNext(this.CurrentFilterService.filterBar);
    return result;
  }

  cancel() {
    this.cancelSubject.onNext(null);
  }

  aggregate_more() {
    this.loadMoreSubject.onNext(null);
  }

  load(params, resetCache) {
    return this.loadWithCache(
      params.url,
      params.params,
      this.canceller,
      resetCache,
    );
  }

  getUrl(filter) {
    return filter.skipStat ?
      '/analytics/values/' + this.CurrentModelService.cube.name + '/' :
      '/analytics/aggregate/' + this.CurrentModelService.cube.name + '/';
  }

  onCancel() {
    if (!this.loading && !this.loadingMore || !this.canceller) {
      console.error('nothing to cancel');
      return;
    }
    this.canceller.resolve('abort');
    this.canceller = null;
    this.loading = false;
    this.loadingMore = false;
    this.isComplete = false;
    if (this.page > 0) {
      this.page = this.page - 1;
      this.cancelledMore = true;
    } else {
      this.cancelled = true;
    }
    this.$rootScope.$evalAsync(() => {
    });
    // console.log('cancel aggregate page', this.page);
  }

  beforeLoad() {
    if (this.loading || this.loadingMore || this.canceller) {
      console.error('load already in progress');
    }
    this.canceller = this.$q.defer();
    this.loading = this.page === 0;
    this.loadingMore = this.page !== 0;
    this.cancelled = false;
    this.cancelledMore = false;
    this.isComplete = false;
    this.error = null;
    this.$rootScope.$evalAsync(() => {
    });
    // console.log('load aggregate page', this.page);
  }

  afterLoad(data) {
    if (!this.loading && !this.loadingMore) {
      console.error('load not in progress');
    }
    this.loading = false;
    this.loadingMore = false;
    this.canceller = null;
    this.isComplete = data.cells.length < this.filter.limit;
    if (this.page === 0) {
      this.aggregate = data;
    } else {
      this.aggregate.cells = this.aggregate.cells.concat(data.cells);
    }
    this.$rootScope.$evalAsync(() => {
    });
    // console.log('done aggregate page', this.page);
  }

  onError(error) {
    this.loading = false;
    this.loadingMore = false;
    this.canceller = null;
    this.isComplete = false;
    if (this.page > 0) {
      this.page = this.page - 1;
    }
    this.ErrorHandlerService.handle(error);
    this.$rootScope.$evalAsync(() => {
    });
    console.error('load aggregate page', this.page, error);
  }
}



// WEBPACK FOOTER //
// ./src/core/aggregate-data.service.js